import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from 'react';
import { useSpring, animated } from 'react-spring';
import Button, { ButtonColors } from '../button';
import classnames from 'classnames/bind';
import styles from './styles.scss';
const cx = classnames.bind(styles);
const CountdownButton = ({ seconds = 5, confirmRole, confirmColor, confirmLabel = 'Click to Confirm:', onClick, role: _role, color: _color, children, disabled, style = {}, reInitialize = false, ...rest }) => {
    const [count, setCount] = useState(-1);
    const [role, setRole] = useState(_role);
    const [color, setColor] = useState(_color);
    const [done, setDone] = useState(false);
    const [onClickArgs, setOnClickArgs] = useState();
    const barStyles = useSpring({
        from: { width: count > 0 ? '100%' : '0%' },
        to: { width: '0%' },
        config: { duration: seconds * 1000 },
        reset: count === seconds,
    });
    useEffect(() => {
        setRole(_role);
    }, [_role]);
    useEffect(() => {
        setColor(_color);
    }, [_color]);
    useEffect(() => {
        if (count === 0 || done) {
            setRole(_role);
            setColor(_color);
        }
    }, [_role, _color, count, done]);
    useEffect(() => {
        if (reInitialize && done) {
            setDone(false);
            setCount(-1);
        }
    }, [reInitialize, done]);
    const onClickHandler = (event, data) => {
        if (count > 0) {
            if (onClickArgs && onClick) {
                onClick(onClickArgs?.event, onClickArgs?.data);
            }
            setRole(_role);
            setDone(true);
        }
        else {
            setRole(confirmRole || _role);
            setColor(confirmColor || _color || ButtonColors.Action);
            setOnClickArgs({ event, data });
            setCount(seconds);
        }
    };
    useEffect(() => {
        if (count === 0 || done) {
            return;
        }
        const timerId = setTimeout(() => setCount(count - 1), 1000);
        return () => clearTimeout(timerId);
    }, [count, done, onClick, onClickArgs]);
    return (_jsxs("div", { className: cx('countdown-button'), style: style, children: [_jsx(Button, { onClick: onClickHandler, role: role, color: color || ButtonColors.Action, disabled: disabled || done, ...rest, children: count > 0 ? `${confirmLabel} ${count}` : children }), count > 0 && (_jsx(animated.div, { className: cx('bar', role === 'primary' ? 'white' : color), style: {
                    ...barStyles,
                    height: '3px',
                    marginTop: '-3px',
                } }))] }));
};
export default CountdownButton;
//# sourceMappingURL=index.js.map